export const testAttributes = {
    AUTHOR_BY_CONTAINER: 'author_byline_container_item',
    AUTHOR_BY_LABEL: 'author_by_label_',
    AUTHOR_LINK: 'author_link_'
};

export const ariaLabels = {
    AUTHOR_LINK: 'tool tip'
};